import { meiucaService } from './MeiucaService'

/**
 * Endpoint do fluxo "Sign in with Meiuca" — emite o linkToken (JWT
 * curto, single-use) que prova "esse AppUser X autoriza ligar ao
 * Customer com phone Y".
 *
 * Pré-condição: AppUser logado no app-web (cookie de sessão presente).
 * O backend valida que `phone` (normalizado) bate com o phone do
 * AppUser — se divergir, lança 400 `phone_mismatch`.
 */

interface IssueLinkTokenRequest {
  phone: string
  intent: string
}

interface IssueLinkTokenResponse {
  data: {
    linkToken: string
    expiresIn: number
  }
}

class ConnectService {
  private service = meiucaService

  async issueLinkToken(request: IssueLinkTokenRequest): Promise<IssueLinkTokenResponse['data']> {
    const response = await this.service.post<IssueLinkTokenResponse>(
      '/auth/connect/issue-link-token',
      request
    )
    return response.data.data
  }
}

export const connectService = new ConnectService()
